module.exports = __webpack_public_path__ + "img/img_dianying.205f233f.png";